<template lang="pug">
  section.banner
    .banner__animation(
      id="lottie-animation-banner"
    )
    p.banner__title(
      v-if="title"
    ) {{title}}
    p.banner__text(
      v-if="text"
    ) {{text}}
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import LazeikaFavorites from '~/assets/lottie/lazeika-favorites.json';
  import LazeikaComments from '~/assets/lottie/lazeika-comments.json';
  import LazeikaNotifications from '~/assets/lottie/lazeika-notifications.json';
  import { createScriptIfNeeded } from '../../utils/embeds';

  export default defineNuxtComponent({
    name: 'BannerNoData',

    props: {
      title: {
        type: String as PropType<string>,
        default: '',
      },
      text: {
        type: String as PropType<string>,
        default: '',
      },
      animationLoaderPath: {
        type: String as PropType<string>,
        default: null,
      },
    },

    setup() {
      return {
        route: useRoute(),
      };
    },

    async mounted() {
      await createScriptIfNeeded('/js/lottie.min.js');

      const animationImports = {
        'profile-comments': LazeikaComments,
        'profile-notifications': LazeikaNotifications,
        'profile-favorites': LazeikaFavorites,
      } as Record<string, unknown>;

      const routeName = this.route.name?.toString() ?? '';

      const animation = window.lottie.loadAnimation({
        container: document.getElementById('lottie-animation-banner'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animationImports[routeName],
      });

      animation.play();
    },
  });
</script>

<style lang="scss" scoped>
  :root {
    --banner-image-path: none;
  }

  .banner {
    text-align: center;
    margin: 0 auto;

    &__title {
      @include fontH4AccentNormalText;
    }

    &__text {
      @include fontSmallText;
    }

    &__title + &__text {
      margin-top: 4px;
    }

    &__animation {
      margin: 0 auto;
      height: 204px;
      width: 204px;
      @include tablet {
      }
    }
  }
</style>
